import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import GridIcon from '@/components/Icons/GridIcon';
import ListIcon from '@/components/Icons/ListIcon';

import { ViewMode } from '../../types';
import { ViewModesProps } from './types';

function ViewModes({ viewMode, setViewMode }: ViewModesProps) {
  return (
    <ToggleButtonGroup
      // color="primary"
      exclusive
      value={viewMode}
      onChange={(_, value) => {
        if (value !== null) setViewMode(value);
      }}
    >
      <ToggleButton value={ViewMode.Grid}>
        <GridIcon />
      </ToggleButton>
      <ToggleButton value={ViewMode.List}>
        <ListIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default ViewModes;
